import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import CheckboxParameter from './CheckboxParameter.js';
import ResolutionDropdown from './ResolutionDropdown.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {setContextualHelp} from "actions/index.js";
import { connect } from "react-redux";

class ChordRhythmEffect extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    render() {
        return (
            <div>
              <ConditionedComponent condition={this.isEnabled()}>
                <div className="clear-fix"/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Duration Factor'}
                  parameter={this.props.effect.durationFactorParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  automation={this.props.automation}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.01}
                  min={0.1}
                  max={2}/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Even Delay Time'}
                  automation={this.props.automation}
                  parameter={this.props.effect.oddDelayTimeParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={0.01}
                  max={16}/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Odd Delay Time'}
                  automation={this.props.automation}
                  parameter={this.props.effect.evenDelayTimeParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={0.01}
                  max={16}/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Repeats'}
                  automation={this.props.automation}
                  parameter={this.props.effect.repeatsParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={1}
                  max={8}/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Velocity Spread'}
                  automation={this.props.automation}
                  parameter={this.props.effect.velocitySpreadParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.01}
                  min={1}
                  max={100}/>
               <CheckboxParameter name="Synced" parameter={this.props.effect.syncedParameter}/>
             </ConditionedComponent>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(null, mapDispatchToProps)(ChordRhythmEffect);
